<template>
  <t-container>
    <div class="flex flex-wrap justify-center">
      <!--      Tabs -->
      <ul class="flex list-none py-4 flex-row text-center text-white ">
        <li>
          <a
            class="font-bold pb-1 text-xl text-white mx-5 cursor-pointer"
            :class="{ 'border-b-2 border-white': openTab === 1 }"
            @click="toggleTabs(1)"
          >
            Individuals
          </a>
        </li>
        <li>
          <a
            class="font-bold text-xl pb-1 text-white mx-5 cursor-pointer"
            :class="{ 'border-b-2 border-white': openTab === 2 }"
            @click="toggleTabs(2)"
          >
            Group Learning
          </a>
        </li>
      </ul>
      <!--      Tab Content -->
      <div
        id="sub-options"
        class="w-full py-4 px-4"
      >
        <!--        Tab 1 -->
        <div
          :class="{ 'hidden': openTab !== 1, 'block flex': openTab === 1 }"
          class="justify-center"
        >
          <div
            v-if="threeCards"
            class="grid p-4 grid-rows-3 lg:grid-rows-1 grid-cols-1 lg:grid-cols-3 gap-5 mx-auto max-w-screen-lg"
          >
            <subcards-online-access
              :large="true"
              :short-card="false"
            >
              <template #button>
                <t-button
                  variant="ctaPrimary"
                  class="py-2 px-16 py-2"
                  @click="goToPage('/subscription/subscription-v2')"
                >
                  Learn More <t-icon
                    name="chevron-right"
                    class="ml-2"
                  />
                </t-button>
              </template>
            </subcards-online-access>
            <subcards-virtual-access
              :large="true"
              :short-card="false"
            >
              <template #button>
                <t-button
                  variant="ctaPrimary"
                  class="py-2 px-16 py-2"
                  @click="goToPage('/subscription/subscription-v2')"
                >
                  Learn More <t-icon
                    name="chevron-right"
                    class="ml-2"
                  />
                </t-button>
              </template>
            </subcards-virtual-access>
            <subcards-all-access
              :large="true"
              :short-card="false"
            >
              <template #button>
                <t-button
                  variant="ctaPrimary"
                  class="py-2 px-16 py-2"
                  @click="goToPage('/subscription/subscription-v2')"
                >
                  Learn More <t-icon
                    name="chevron-right"
                    class="ml-2"
                  />
                </t-button>
              </template>
            </subcards-all-access>
          </div>
          <div
            v-else
            class="grid grid-rows-2 lg:grid-rows-1 grid-cols-1 lg:grid-cols-5 gap-5 mx-auto max-w-screen-xl"
          >
            <subcards-core :large="threeCards">
              <template #button>
                <nuxt-link
                  class="font-bold text-text-secondary"
                  to="/subscription/subscription-v2"
                >
                  Learn More >
                </nuxt-link>
              </template>
            </subcards-core>
            <subcards-core-plus :large="threeCards">
              <template #button>
                <nuxt-link
                  class="font-bold text-text-secondary"
                  to="/subscription/subscription-v2"
                >
                  Learn More >
                </nuxt-link>
              </template>
            </subcards-core-plus>
            <subcards-online-access :large="threeCards">
              <template #button>
                <nuxt-link
                  class="font-bold text-text-secondary"
                  to="/subscription/subscription-v2"
                >
                  Learn More >
                </nuxt-link>
              </template>
            </subcards-online-access>
            <subcards-virtual-access :large="threeCards">
              <template #button>
                <nuxt-link
                  class="font-bold text-text-secondary"
                  to="/subscription/subscription-v2"
                >
                  Learn More >
                </nuxt-link>
              </template>
            </subcards-virtual-access>
            <subcards-all-access :large="threeCards">
              <template #button>
                <nuxt-link
                  class="font-bold text-text-secondary"
                  to="/subscription/subscription-v2"
                >
                  Learn More >
                </nuxt-link>
              </template>
            </subcards-all-access>
          </div>
        </div>
        <!--        Tab 2 -->
        <div
          :class="{ 'hidden': openTab !== 2, 'block flex': openTab === 2 }"
          class="justify-center"
        >
          <div class="max-w-screen-xl mx-auto p-4 grid grid-flow-col lg:grid-cols-4 lg:grid-rows-1 grid-rows-4 grid-cols-1 gap-6">
            <subcards-online-access
              :large="threeCards"
              :group="true"
              :short-card="false"
            >
              <template #button>
                <div>
                  <t-button
                    variant="ctaPrimary"
                    class="py-2 px-16 py-2"
                    @click="goToPage('/group-sales')"
                  >
                    Learn More <t-icon
                      name="chevron-right"
                      class="ml-2"
                    />
                  </t-button>
                </div>
              </template>
            </subcards-online-access>
            <subcards-virtual-access
              :large="threeCards"
              :group="true"
              :short-card="false"
            >
              <template #button>
                <div>
                  <t-button
                    variant="ctaPrimary"
                    class="py-2 px-16 py-2"
                    @click="goToPage('/group-sales')"
                  >
                    Learn More <t-icon
                      name="chevron-right"
                      class="ml-2"
                    />
                  </t-button>
                </div>
              </template>
            </subcards-virtual-access>
            <subcards-all-access
              :large="threeCards"
              :group="true"
              :short-card="false"
            >
              <template #button>
                <div>
                  <t-button
                    variant="ctaPrimary"
                    class="py-2 px-16 py-2"
                    @click="goToPage('/group-sales')"
                  >
                    Learn More <t-icon
                      name="chevron-right"
                      class="ml-2"
                    />
                  </t-button>
                </div>
              </template>
            </subcards-all-access>
            <subcards-customized-packages
              :large="threeCards"
              :group="true"
              :short-card="false"
            >
              <template #button>
                <div>
                  <t-button
                    variant="ctaPrimary"
                    class="py-2 px-16 py-2"
                    @click="goToPage('/group-sales')"
                  >
                    Learn More <t-icon
                      name="chevron-right"
                      class="ml-2"
                    />
                  </t-button>
                </div>
              </template>
            </subcards-customized-packages>
          </div>
        </div>
      </div>
    </div>
    <subcards-hep-horizontal />
  </t-container>
</template>

<script>
export default {
  name: 'SubscriptionOptions',
  props: {
    threeCards: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openTab: 1,
      showModal: false,
    };
  },
  methods: {
    toggleTabs(tabNumber) {
      this.openTab = tabNumber;
    },
    goToPage(page) {
      this.$router.push(page);
    },
  },
};
</script>
